import React from 'react';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import './App.css';
import AutoDownload from './components/AutoDownload';
import MainLayout from './components/MainLayout';
import { links } from './enums';
import MainPage from './views/Main';
import PrivacyPolicy from './views/PrivacyPolicy';
import UserAgreement from './views/UserAgreement';
import CookieBanner from './components/CookieBanner';
import PageMetadata from './components/PageMetadata';

const RedirectToHome: React.FC = () => {
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={{ pathname: links.main, search, hash }}
      replace
    />
  );
};

const App: React.FC = () => (
  <div className="App">
    <PageMetadata />
    <Routes>
      <Route element={<MainLayout />}>
        <Route
          element={<MainPage />}
          path={links.main}
        />
        <Route
          element={<PrivacyPolicy />}
          path={links.privacyPolicy}
          caseSensitive
        />
        <Route
          element={<UserAgreement />}
          path={links.userAgreement}
          caseSensitive
        />
      </Route>
      <Route
        element={<AutoDownload />}
        path={links.portfolio}
        caseSensitive
      />
      <Route
        element={<RedirectToHome />}
        path="*"
      />
    </Routes>
    <CookieBanner />
  </div>
);

export default App;
